import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { resyncWebPush } from '../services/web-push.service';
import { useAuthStore } from '../stores/auth.store';
import { beginSessionFlow } from '../stores/session-read';

/**
 * Web: re-send this browser's existing push subscription for whoever signed
 * in (a row dropped on 404/410, a browser that changed accounts, a rotated
 * VAPID key). Never prompts; the 1:1 page's card and Notification settings ask.
 *
 * Once per SESSION, keyed on the token (c-027): the server re-owns an endpoint
 * for whoever registers it, so this is what moves the browser to B on a
 * direct switch A→B, where `isAuthenticated` stays true and never re-fired.
 */
export function useWebPushResync(): void {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const token = useAuthStore((s) => s.token);
  useEffect(() => {
    if (!isAuthenticated || !token || Capacitor.isNativePlatform()) return;
    void resyncWebPush(beginSessionFlow().isCurrent);
  }, [isAuthenticated, token]);
}
